export default "__VITE_ASSET__Du9WO_QY__"